export const  optionSelect = () => {
    let container = document.querySelectorAll(
      ".trivia__container fieldset"
    ) as any;
    let arrayContainer = [...container];
    for (let i = 0; i < arrayContainer.length; i++) {
      if (arrayContainer[i].classList.contains("trivia__answer--active")) {
        for (let j = 0; j < arrayContainer[i].children.length; j++) {
          if (!arrayContainer[i].children[j].classList.contains("form__option")) {
            arrayContainer[i].children[j].addEventListener("click", (e: any) => {
              for (let j = 0; j < arrayContainer[i].children.length; j++) {
                arrayContainer[i].children[j].classList.remove(
                  "form__option--active"
                );
              }
              arrayContainer[i].children[j].classList.add("form__option--active");
            });
          }
        }
      }
    }
    //imagenes
    let selectImsg = document.querySelectorAll('.trivia__answer--active .form__row .form__col .form__option') as any; //selecciona las opciones imagen de la pregunta activa
    let arraySelectImsg = [...selectImsg];
    for (let i = 0; i < arraySelectImsg.length; i++) {
      arraySelectImsg[i].addEventListener("click", (e: any) => {
        for (let j = 0; j < arraySelectImsg.length; j++) {
          arraySelectImsg[j].classList.remove(
            "form__option--imgActive"
          );
        }
        arraySelectImsg[i].classList.add('form__option--imgActive');
      });
    }
}